export default {"src":"/newStatic/_next/static/media/play-store-icon.5fe1a615.svg","height":24,"width":24};